import * as React from 'react';

import Alert from 'antd/es/alert';

import loadable from '@common/react/loadable/loadableSettings';
import Loader from '@common/react/components/Core/LoaderProvider/Loader';
import ItemsProviderWithStore from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';

import { BaseTemplateSnapshot } from '@commonTuna/react/objects/BaseTemplateSnapshot';
import { BaseInvite } from '@commonTuna/react/objects/BaseInvite';

import '@app/scss/components/signHipaa.scss';

const ConsentFormSwitcher = loadable(() =>
	import(/* webpackChunkName: "ConsentFormSwitcher" */ '@commonTuna/react/components/UI/ConsentForm/ConsentFormSwitcher'));

interface ComponentProps {
	renderButtons?: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit?: (items: Array<any>) => void;
	alertContent?: React.ReactNode;
	className?: string;
}

export const SignHipaa: React.FC<ComponentProps> = (props) => {
	const [templateIndex, setTemplateIndex] = React.useState<number>(0);
	const [templateSnapshot, setTemplateSnapshot] = React.useState<BaseTemplateSnapshot | undefined>();

	const initHandler = (items) => {
		!items?.length && handleSubmit([]);
	};

	const setNextTemplate = (items, setItems) => {
		const nextTemplateIndex = templateIndex + 1;
		if (nextTemplateIndex < items.length) {
			setTemplateIndex(nextTemplateIndex);
		} else {
			setItems((prev) => prev.filter((item) => !items.includes(item)));
			setTimeout(() => {
				handleSubmit(items);
			}, 0);
		}
	};

	const handleSubmit = (items) => {
		props.afterSubmit && props.afterSubmit(items);
	};

	return <ItemsProviderWithStore<BaseInvite>
		storeName="companyTemplateInvites"
		loadRequest="inviteList"
		pagination={{ current: 1, pageSize: 100 }}
		filters={{
			isCompanyTemplate: true,
			isAnswered: false,
			onlyFirstCopy: true,
		}}
		onLoad={(res) => initHandler(res.list)}
	>
		{({ state: { items: companyTemplateInvites, loading }, actions }) => {
			const solvedItems = companyTemplateInvites.filter((item) => item.templateSnapshot && item.isCompanyTemplate);
			return <div className={`sign-hipaa ${props.className}`}>
				<div className="contact-text mt10 mb10">
					<Alert
						message={<>
							{props.alertContent || 'Sign HIPAA (Health Insurance Portability and Accountability Act) form:'}
							{' '}
							{templateSnapshot ? templateSnapshot.name : ''}
							<br />
							<strong>Signature required at the bottom - please scroll down</strong>
						</>}
						type="info"
					/>
				</div>
				{solvedItems.length > 1 ? <div className="mb10">
					<b>
						{templateIndex + 1}
						{' / '}
						{solvedItems.length}
					</b>
				</div> : null}
				{(solvedItems[templateIndex]?.templateSnapshot && (solvedItems[templateIndex]?.templateSnapshot?.id ?? 0) > 0)
					? <div className="panel panel-default" style={{ width: '100%', maxWidth: '800px' }}>
						<div className="panel-body" style={{ height: '80vh' }}>
							<ConsentFormSwitcher
								key={templateIndex}
								showPdf={false}
								queryParams={{
									appointmentProcedureId: 0,
									templateSnapshotId: solvedItems[templateIndex]?.templateSnapshotId,
									appointmentId: solvedItems[templateIndex]?.appointmentId,
									diseaseId: solvedItems[templateIndex]?.diseaseId,
									inviteId: solvedItems[templateIndex]?.id,
									patientId: solvedItems[templateIndex]?.patientId,
								} as any}
								onAccept={() => {
									setNextTemplate(solvedItems, actions.setItems);
								}}
								onCancel={() => undefined}
								patientFileId={solvedItems[templateIndex]?.patientFileId}
								enableSave
								initTemplateSnapshot={solvedItems[templateIndex]?.templateSnapshot ?? undefined}
								getTemplateSnapshot={setTemplateSnapshot}
								showCloseButton={false}
							/>
						</div>
					</div>
					: !solvedItems.length && !loading
						? (
							<>
								<div>
									<div>
										All HIPAA Forms confirmed
									</div>
								</div>
								{props.renderButtons && props.renderButtons(() => handleSubmit([]))}
							</>
						)
						: <Loader />
				}
			</div>;
		}}
	</ItemsProviderWithStore>;
};
